export default "__VITE_ASSET__Dutxc4wS__"